import React, { Component } from 'react';
import { connect } from 'react-redux';
import { BrowserRouter as Router, Redirect, Route, Link, NavLink, Switch} from 'react-router-dom'; //Link,
import PrivateRoute from './PrivateRoute';
import Login from './components/Login/Login';
import MapView from './components/MapView';
import TableView from './components/TableView';
import PublicView from './components/PublicView';
import { doLogout } from './actions/login'

class Navigation extends Component {
  constructor(props){
    super(props)
    this.state = { showNav: false, version: ' 0.1.0' }
  }

  clickLogout(){
    this.props.dispatch(doLogout())
  }
  toggleNav(show){
    this.setState({showNav:show})
  }

  render(){
    let selectedProperty = this.props.selectedProperty !== null ? "Property: " +  this.props.selectedProperty : null
    let navClass = this.state.showNav ? 'show' : '';

    return(
      <div>
        <Router>
          <div>
          { this.props.show && this.props.showNav ? (
            <nav className="navbar navbar-expand-lg bg-dark">
              <a className="navbar-brand">Property Explorer</a>
              <button className="navbar-toggler collapsed"
                type="button"
                data-toggle="collapse"
                data-target="#navbarColor01"
                aria-controls="navbarColor01"
                aria-expanded="false"
                aria-label="Toggle navigation"
                onClick={this.toggleNav.bind(this,!this.state.showNav)}
              >
                  <span className="navbar-toggler-icon"></span>
                </button>
              <div className={"collapse navbar-collapse" + navClass} id="navbarColor01">
                <ul className="navbar-nav mr-auto" onClick={this.toggleNav.bind(this,false)}>
                  <li className="nav-item"><NavLink className='nav-link' activeClassName='nav_active' to="/map">Map</NavLink></li>
                  <li className="nav-item"><NavLink className='nav-link' activeClassName='nav_active' to="/table">Table</NavLink></li>
                  <span className="navbar-text float-left navSelectedProperty" style={{display: selectedProperty ? "block":"none"}}>{selectedProperty}</span>
                </ul>
                <ul className="navbar-nav" onClick={this.toggleNav.bind(this,false)}>
                  <li className="nav-item"><Link className='nav-link' onClick={this.clickLogout.bind(this)} to="/map">Logout</Link></li>
                </ul>
              </div>
            </nav> ) : (null) }
            <div>
              <Switch>
                <PrivateRoute exact path="/map" component={ MapView } />
                <PrivateRoute exact path="/table" component={ TableView } />
                <Route exact path="/login" component={ Login } />
                <Route exact path="/public" component={ PublicView } />
                <Redirect from="/" to="/map"/>
              </Switch>
            </div>
          </div>
        </Router>
        <div id='busyIndicator' className={this.props.isBusy ? 'isBusy' : 'isNotBusy'} >
          {this.props.busyText}
        </div>
      </div>
    );
  }
}


const mapStateToProps = (state) => {
  return {
    isBusy: state.isBusy,
    busyText: state.busyText,
    selectedProperty: state.DataApp.get('selectedProperty'),
    show: state.LoginApp.loggedIn,
    showNav: state.showNav
  };
}

export default connect(mapStateToProps)(Navigation);



// WEBPACK FOOTER //
// ./src/Navigation.js